// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._lS8AJpT21Motc40zBlu {
  background: rgba(0, 0, 0, 0.9);
  border-radius: 12px;
  padding: 16px;
  margin: 8px;
  color: white;
  font-family: system-ui, -apple-system, sans-serif;
  min-width: 280px;
  max-width: 320px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
}

.wCIeoUuYE1qWRrcizJrA {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background: rgba(0, 0, 0, 0.8);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  transition: all 0.2s ease;
  z-index: 1000;
}
.wCIeoUuYE1qWRrcizJrA:hover {
  background: rgba(0, 0, 0, 0.9);
  border-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}
.wCIeoUuYE1qWRrcizJrA:active {
  transform: scale(0.95);
}

.IzeODxIrFdrTDP9wWbek {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.S84yLVGfQu65BMTvrOwM {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.xH0WaFIdom2Oo7gy7JBQ {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}
.xH0WaFIdom2Oo7gy7JBQ:hover {
  color: white;
  background: rgba(255, 255, 255, 0.1);
}

.CcX2jAmyOlI9LnxrkBYB {
  margin-bottom: 20px;
}
.CcX2jAmyOlI9LnxrkBYB:last-child {
  margin-bottom: 0;
}

.Q4n22wBvSCzTl2yiKzhB {
  display: block;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 10px;
  color: rgba(255, 255, 255, 0.9);
}

.VC4bXc3CzCAR1p7VIVkj {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.2);
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.VC4bXc3CzCAR1p7VIVkj:hover {
  background: rgba(255, 255, 255, 0.3);
}
.VC4bXc3CzCAR1p7VIVkj::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  border: 3px solid #007bff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  transition: all 0.2s ease;
}
.VC4bXc3CzCAR1p7VIVkj::-webkit-slider-thumb:hover {
  transform: scale(1.1);
  border-color: #0056b3;
}
.VC4bXc3CzCAR1p7VIVkj::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  border: 3px solid #007bff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.cNLMVygd8_lQBK7_ti7T {
  width: 100%;
  padding: 10px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.cNLMVygd8_lQBK7_ti7T:hover {
  background: #0056b3;
}
.cNLMVygd8_lQBK7_ti7T:active {
  background: #004085;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/viewport/ARControls/ARControls.module.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,iDACE;EAGF,gBAAA;EACA,gBAAA;EACA,yCAAA;EACA,2BAAA;AAFF;;AAKA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,0CAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,aAAA;AAFF;AAIE;EACE,8BAAA;EACA,sCAAA;EACA,sBAAA;AAFJ;AAKE;EACE,sBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iDAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AAJF;;AAOA;EACE,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAJF;AAME;EACE,YAAA;EACA,oCAAA;AAJJ;;AAQA;EACE,mBAAA;AALF;AAOE;EACE,gBAAA;AALJ;;AASA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AANF;;AASA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AANF;AAQE;EACE,oCAAA;AANJ;AASE;EACE,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,yBAAA;AAPJ;AAUE;EACE,qBAAA;EACA,qBAAA;AARJ;AAWE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;AATJ;;AAaA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AAVF;AAYE;EACE,mBAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"arControls": `_lS8AJpT21Motc40zBlu`,
	"toggleButton": `wCIeoUuYE1qWRrcizJrA`,
	"header": `IzeODxIrFdrTDP9wWbek`,
	"title": `S84yLVGfQu65BMTvrOwM`,
	"closeButton": `xH0WaFIdom2Oo7gy7JBQ`,
	"controlGroup": `CcX2jAmyOlI9LnxrkBYB`,
	"label": `Q4n22wBvSCzTl2yiKzhB`,
	"slider": `VC4bXc3CzCAR1p7VIVkj`,
	"actionButton": `cNLMVygd8_lQBK7_ti7T`
};
export default ___CSS_LOADER_EXPORT___;
